import { onlineManager } from '@tanstack/react-query'
import { useEffect, useState } from 'react'
import { Icon } from '@/shared/ui'
import s from './OfflineBanner.module.css'

/**
 * Полоса «нет соединения».
 *
 * Слушаем `onlineManager` из TanStack Query, а не `navigator.onLine` напрямую, и это не вкусовщина:
 * именно `onlineManager` решает, останавливать ли запросы и когда возобновлять. Возьми мы своё
 * определение «онлайна» — баннер мог бы показывать одно, а слой данных вести себя по-другому.
 *
 * `role="status"`, а не `alert`: пропавшая сеть — это состояние, а не срочная ошибка. `alert`
 * перебил бы скринридеру то, что человек читает.
 */
export function OfflineBanner() {
  const [online, setOnline] = useState(() => onlineManager.isOnline())

  useEffect(() => onlineManager.subscribe(setOnline), [])

  if (online) return null

  return (
    <div className={s.root} role="status">
      <Icon name="wifi-off" size={14} strokeWidth={1.9} className={s.icon} />
      Нет соединения. Данные обновятся, когда сеть вернётся.
    </div>
  )
}
